class StickyHeader extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.stickyEnabled = this.dataset.headerSticky === 'true'
		this.hideOnScroll = true
		this.isSticky = false
		this.header = document.querySelector('.f-section-header')
		if (this.stickyEnabled) this.initStickyHeader()
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this._hideHeaderOnScrollUp)
		window.removeEventListener('scroll', this.onScrollHandler)
	}

	initStickyHeader() {
		this.currentScrollTop = 0
		this.preventReveal = false

		this.onScrollHandler = this._onScroll.bind(this)
		this._hideHeaderOnScrollUp = () => this.preventReveal = true

		this.addEventListener('preventHeaderReveal', this._hideHeaderOnScrollUp)
		window.addEventListener('scroll', this.onScrollHandler, false)

		this.rectTop = this.header.offsetTop
		this.offset = this.header.offsetTop + this.header.clientHeight

		document.body.classList.add('header-sticky-enabled')
	}

	_onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop
		if(this.hideOnScroll) {
			if (scrollTop > this.currentScrollTop && scrollTop > this.offset) {
				requestAnimationFrame(this._hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.offset) {
				if (!this.preventReveal) {
					requestAnimationFrame(this._reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)
	
					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)
	
					requestAnimationFrame(this._hide.bind(this))
				}
			} else if (scrollTop <= this.rectTop) {
				requestAnimationFrame(this._reset.bind(this))

				const navSwitchBar = document.getElementById('nav-switch-bar');
				if(navSwitchBar !== null){
					navSwitchBar.style.setProperty('position', 'static');
				}
				this.header.querySelector('.site-header__wrapper').style.setProperty('margin-top', '0px')

			}
		}
		this.currentScrollTop = scrollTop
	}

	_hide() {
		if( this.isSticky ) {
			this.isSticky = false
			this.header.classList.add('site-header--sticky', 'site-header--hidden')

			const navSwitchBar = document.getElementById('nav-switch-bar');

			//Remove margin top margin from navigation
			this.header.querySelector('.site-header__wrapper').style.setProperty('margin-top', '0px')
	
			//Set opacity of navSwitchBar to 0
			if(navSwitchBar !== null) {
				navSwitchBar.style.setProperty('opacity', '0');
				navSwitchBar.style.setProperty('transition', 'opacity 0.2s');
			}

			document.body.classList.remove('header-sticky--visible')
			this._closeMenuDisclosure()
		}
	}

	_reveal() {
		if( ! this.isSticky ) {
			this.isSticky = true
			this.header.classList.add('site-header--sticky', 'site-header--animate')
			this.header.classList.remove('site-header--hidden')

			const navSwitchBar = document.getElementById('nav-switch-bar');

			if(navSwitchBar !== null) {
	
				//Add margin top margin to navigation to make space for toggle switcher bar
				this.header.querySelector('.site-header__wrapper').style.setProperty('margin-top', navSwitchBar.clientHeight + 'px')
	
				//Set posotion sticky of navSwitchBar
				navSwitchBar.style.setProperty('opacity', '1');
				navSwitchBar.style.setProperty('position', 'fixed');
				navSwitchBar.style.setProperty('top', '0');
				navSwitchBar.style.setProperty('width', '100%');
				navSwitchBar.style.setProperty('z-index', '767');
			}
			
			document.body.classList.add('header-sticky--visible')
		}
	}

	_reset() {
		this.isSticky = false
		this.header.classList.remove('site-header--hidden', 'site-header--sticky', 'site-header--animate')
		document.body.classList.remove('header-sticky--visible')
	}

	_closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
		this.disclosures.forEach(disclosure => disclosure.close());

		this.siteNav = this.siteNav || this.header.querySelector('site-nav');
		this.siteNav && this.siteNav.closeMegaDropdowns()
	}
}

customElements.define('sticky-header', StickyHeader)
